import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { connect } from 'dva';
import styles from './ErrorMigration.less'
import logo from 'assets/svg/new_logo.png';
import ds from 'assets/migration/ds.png'
import shopify from 'assets/migration/shopify.png'
import update from 'assets/migration/update.png'
import serveError from 'assets/migration/500.png'
import { Button, Dropdown, Menu } from 'antd';
import SelectLanguage from 'components/GlobalHeader/SelectLanguage';
import intl from 'react-intl-universal'

function ErrorMigration({userInfo, migrationInfo}) {

    const [errorCode, setErrorCode] = useState(1)
    const dispatch = useDispatch()

    useEffect(() => {
        const code = window.location.search?.split('?')[1]
        setErrorCode(code?.split('=')[1] == 500 ? 1 : 2)
    }, [])

    const menu = (
        <Menu>
            <Menu.Item onClick={() => {
                dispatch({
                    type: 'login/logout'
                });
            }}>
                <div>Log Out</div>
            </Menu.Item>
        </Menu>
    )





    return (
        <div className={styles.container}>
            <div className={styles.top}>
                <img src={logo} alt="" />
                <div className={styles.user}>
                    <div style={{ lineHeight: '64px' }}><SelectLanguage /></div>
                    <div></div>
                    <div><img src={shopify} alt="" /> {migrationInfo?.migrating_shopify_domain}</div>
                    <div></div>
                    <div className={styles.dropimg}><img src={ds} alt="" /></div>
                    <div><Dropdown overlay={menu} trigger={['hover']}>
                        <span className={styles.drop}>
                            <span>{userInfo.email}</span>
                            <i style={{ position: 'relative', top: '2px', marginLeft: '10px' }} className="material-icons">arrow_drop_down</i>
                        </span>
                    </Dropdown></div>
                </div>
            </div>

            {
                errorCode == 2 ?
                    (
                        <div className={styles.middle}>
                            <img src={update} alt="" />
                            <div>{intl.get('migration.code_426')}</div>
                            <Button>{intl.get('migration.customerservice')}</Button>
                        </div>
                    ) :
                    (
                        <div className={styles.middle}>
                            <img src={serveError} alt="" />
                            <div>{intl.get('migration.code_500')}</div>
                            <Button>{intl.get('migration.customerservice')}</Button>
                        </div>
                    )
            }



        </div>
    )
}

export default connect(({ login, auth }) => ({
    userInfo: login.userInfo,
    migrationInfo: auth.migrationInfo
}))(ErrorMigration)